import { supabase } from "@/lib/supabase/supabaseClient";

export const updatePassword = async (password: string) => {
    return await supabase.auth.updateUser({ password });
}